<template>
  <div :class="`form-element-viewer ${type}-viewer`">
    <component :is="(type === 'prioritize') ? 'ol' : 'ul'">
      <li
        v-for="(entry, key) in value"
        :key="key"
      >
        {{ entry }}
      </li>
    </component>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Array, default: () => [] },
    type: { type: String, required: true }
  }
};
</script>
